var locked = false; // 滑动锁
/** rem适配 当前像素除以100 **/ !(function (n) {
  var e = n.document,
    t = e.documentElement,
    i = 375,
    d = i / 100,
    o = 'orientationchange' in n ? 'orientationchange' : 'resize',
    a = function () {
      var n = t.clientWidth || 375;
      n > 750 && (n = 375);
      t.style.fontSize = n / d + 'px';
    };
  e.addEventListener &&
    (n.addEventListener(o, a, !1),
      e.addEventListener('DOMContentLoaded', a, !1));
})(window);

var flowNoMap = {};
function randomFlowNo() {
  var random = `${Math.random()}`.substring(2, 12);
  return `FN-${new Date().getTime()}-` + `${random}`;
}
function initAppMethod() {
  /**
   * 暴露方法供原生调用H5方法(传回服务器返回数据结果集)，
   * 即网络请求
   * @param    {String}    flowNo   原生回传的回调函数的id
   * @param    {Object}    paramMap 回调函数的参数
   */
  window.nativeCallback = function nativeCallback(flowNo, param) {
    flowNoMap[flowNo].resolve(param);
  };
  /**
   * 此方法用于原生方法调用，回传全局消息
   * @param    {Object}    paramMap 原生回传的方法
   */
  window.triggerMessage = function triggerMessage(funcName, param) {
    return window[funcName](param);
  };
}
// initAppMethod();
function signal(options) {
  console.log('window.paiLaApi' ,window.paiLaApi );
  
  return window.paiLaApi.signal(options)
  if (!options.funcName) {
    throw new Error('options funcName is not specified');
  }
  var paramMap = Object.assign({}, options);
  // 产生用于promise resolve的唯一编号
  var flowNo = randomFlowNo();
  paramMap.flowNo = flowNo;
  if (systemInfo.system === 'ios') {
    return new Promise((resolve, reject) => {
      flowNoMap[flowNo] = {
        resolve,
        reject,
      };
      window.webkit.messageHandlers.jsCallNative.postMessage(
        JSON.stringify(paramMap)
      );
    });
  } else if (systemInfo.system === 'android') {
    return new Promise((resolve, reject) => {
      flowNoMap[flowNo] = {
        resolve,
        reject,
      };
      window[options.module][options.funcName](JSON.stringify(paramMap));
    });
  }

  return new Promise((resolve, reject) => {
    reject({ errorNo: -1000, results: { errorInfo: '不支持使用插件' } });
  });
}

window.onload = function () {
  // touch相关优化排除canvas；
  var lastTouchEnd = 0;
  document.addEventListener('touchstart', function (event) {
    if (event.target.localName !== 'canvas' && event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener(
    'touchend',
    function (event) {
      if (event.target.localName !== 'canvas') {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      }
    },
    false
  );
  // 阻止双指放大
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault();
  });
  /*阻止滚动时带的tonuchend事件 防止误触*/

  window.addEventListener(
    'touchmove',
    function (ev) {
      const target = ev.target;
      if (target.localName !== 'canvas'
        && !(target.classList.contains('van-picker-column') || target.classList.contains('van-picker-column__item') || target.parentElement.classList.contains('van-picker-column__item'))) {
        locked ||
          ((locked = true),
            window.addEventListener(
              'touchend',
              stopTouchendPropagation,
              true
            ));
      }
    },
    true
  );
  initPlatform();
};

function initPlatform() {
  if (systemInfo.platform !== 'mobile') {
    initPc();
  } else if (systemInfo.environment === 'APP') {
    initApp();
  } else {
    initBrowser();
  }
}

function initPc() {
  alert('请用手机访问');
}

function initApp() {
  var app = window.app;
}

function initBrowser() { }

// APP交互代码

// function install() {
//     window.nativeCallback = function nativeCallback(flowNo, paramMap) {
//         const { errorNo, results } = paramMap;
//         if (flowNo) {
//             if (errorNo !== 0) {
//                 flowNoMap[flowNo].reject(paramMap);
//             } else {
//                 flowNoMap[flowNo].resolve(results);
//             }
//             delete flowNoMap[flowNo];
//         }
//     };
//     window.triggerMessage = function triggerMessage(funcNo, paramMap) {
//         msgQueue.notify(funcNo, paramMap);
//     };
// }

// method
function stopTouchendPropagation(ev) {
  if (ev.target.localName !== 'canvas') {
    ev.stopPropagation();
    window.removeEventListener('touchend', stopTouchendPropagation, true);
    locked = false;
  }
}
function zeroize(num) {
  return (String(num).length == 1 ? '0' : '') + num;
}

function initTime() {
  var timeTag = document.getElementsByClassName('formatTime');
  for (var i = 0; i < timeTag.length; i++) {
    timeTag[i].innerHTML = formatTimestamp(parseInt(timeTag[i].innerHTML));
  }
}
function formatTimestamp(timestamp) {
  timestamp = timestamp / 1000;
  var curTimestamp = parseInt(new Date().getTime() / 1000); //当前时间戳
  var timestampDiff = curTimestamp - timestamp; // 参数时间戳与当前时间戳相差秒数
  var curDate = new Date(curTimestamp * 1000); // 当前时间日期对象
  var tmDate = new Date(timestamp * 1000); // 参数时间戳转换成的日期对象
  var Y = tmDate.getFullYear(),
    m = tmDate.getMonth() + 1,
    d = tmDate.getDate();
  var H = tmDate.getHours(),
    i = tmDate.getMinutes(),
    s = tmDate.getSeconds();
  if (timestampDiff < 60) {
    // 一分钟以内
    return '刚刚';
  } else if (timestampDiff < 3600) {
    // 一小时前之内
    return Math.floor(timestampDiff / 60) + '分钟前';
  } else if (
    curDate.getFullYear() == Y &&
    curDate.getMonth() + 1 == m &&
    curDate.getDate() == d
  ) {
    return zeroize(H) + ':' + zeroize(i); // 今天
  } else {
    var newDate = new Date((curTimestamp - 86400) * 1000); // 参数中的时间戳加一天转换成的日期对象
    if (
      newDate.getFullYear() == Y &&
      newDate.getMonth() + 1 == m &&
      newDate.getDate() == d
    ) {
      return zeroize(H) + ':' + zeroize(i); //昨天
    } else if (curDate.getFullYear() == Y) {
      return (
        zeroize(m) +
        '-' +
        zeroize(d) +
        ' ' +
        zeroize(H) +
        ':' +
        zeroize(i)
      ); //今年
    } else {
      return (
        Y +
        '-' +
        zeroize(m) +
        '-' +
        zeroize(d) +
        ' ' +
        zeroize(H) +
        ':' +
        zeroize(i)
      );
    }
  }
}
async function getToken() {
  const res = await signal({
    funcName: 'getToken',
    module: "app",
    param: {},
  })
  return res.token;
}
function idTokenInvalid() {
  signal({
    funcName: 'idTokenInvalid',
    module: "app",
    param: ''
  })
}
function showShare() {
  signal({
    funcName: "showShare",
    module: "web",
    param: {
      show: true,
    }
  })
}
export {
  getToken,
  idTokenInvalid,
  showShare
}

async function updateLoginHintText() {
  try {
    const res = await signal({
      funcName: 'updateLoginHintText',
      module: 'app',
      param: {
        text: "登录获取实时期货数据，把握机会"
      }
    });
    console.log(res);
  } catch (error) {
    console.log('error :>> ', error);
  }
}
async function isMobileLogin() {
  try {
    const res = await signal({
      funcName: 'isMobileLogin',
      module: 'app',
    });
    console.log(res);
    return res;
  } catch (error) {
    console.log('error :>> ', error);
  }
}


try {
  isMobileLogin().then(res => {
    if (!res.success) {
      const timer = setTimeout(() => {
        updateLoginHintText();
        clearTimeout(timer);
      }, 5000);
    }
  })
} catch (error) {
  console.log('error :>> ', error);
}
